module.exports = __webpack_public_path__ + "static/media/sudoku.ed72175a.png";